import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

import Button from '../../../../shared/components/Button';
import List from '../../../../shared/components/List';
import Paragraph from '../../../../shared/components/Paragraph';
import VoiceAccordion from '../../../../shared/components/Accordion';
import VoiceLink from '../../../../shared/components/Link';
import Warning from './Warning';
import MailContent from './MailContent';
import Separator from '../../../../shared/structure/Separator';
import TwoCols from '../../../../shared/structure/TwoCols';

const useStyles = makeStyles((theme) => ({
  link: {
    wordBreak: 'break-all',
  },
  alert: {
    marginTop: -theme.spacing(1),
    '& span': {
      fontSize: '0.8rem',
    },
  },
}));

function SendByEmail({
  copyEMailText,
  copyLink,
  copyLinkText,
  isCopyLoading,
  isCopyMailTextLoaded,
  isCopyMailTextLoading,
  link,
  state,
}) {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <>
      <VoiceAccordion
        title={t('mail_email_title')}
        content={(
          <>
            <List>
              <li>{t('mail_email_instruction_1')}</li>
              <li>
                <Trans
                  i18nKey="mail_email_instruction_2_start"
                />
                <VoiceLink
                  color="primary"
                  href="mailto:zakon@house.gov.by"
                >
                  zakon@house.gov.by
                </VoiceLink>
                <Trans
                  i18nKey="mail_email_instruction_2_end"
                />
                <VoiceLink
                  color="primary"
                  target="_blank"
                  href="https://drive.google.com/file/d/11OQYYtBo9vsodEx_yjHlxVIPNxluNU2R/view?usp=sharing"
                >
                  {t('mail_email_instruction_2_link')}
                </VoiceLink>
              </li>
              <li>
                <Trans
                  i18nKey="mail_email_instruction_3"
                />
                <VoiceLink
                  color="primary"
                  href="http://bit.ly/golos-print-3"
                >
                  http://bit.ly/golos-print-3
                </VoiceLink>
              </li>
              <li>
                <Trans
                  i18nKey="mail_email_instruction_4"
                />
              </li>
            </List>

            <TwoCols
              leftAlign="center"
              rightAlign="center"
              left={(
                <>
                  <Button
                    background="blue"
                    small
                    text={t('mail_copy_text_button')}
                    onClick={copyEMailText}
                    isLoading={isCopyMailTextLoading}
                  />
                  {isCopyMailTextLoaded && (
                    <Paragraph
                      textAlign="center"
                    >
                      <small>
                        {t('mail_copy_attachment_done')}
                      </small>
                    </Paragraph>
                  )}
                </>
              )}
              right={(
                <>
                  {
                    link === '' ? t('mail_link_in_progress') : (
                      <Button
                        background="blue"
                        small
                        text={t('mail_copy_link_button')}
                        onClick={copyLink}
                        isLoading={isCopyLoading}
                      />
                    )
                  }
                  {
                    copyLinkText && (
                      <Paragraph
                        textAlign="center"
                      >
                        <small className={classes.link}>
                          {t('mail_copy_link_done')}
                        </small>
                      </Paragraph>
                    )
                  }
                </>
              )}
            />

            <Warning />

            <Separator />

            <MailContent state={state} />
          </>
        )}
      />
    </>
  );
}

SendByEmail.defaultProps = {
  copyLinkText: '',
  isCopyLoading: false,
  isCopyMailTextLoaded: false,
  isCopyMailTextLoading: false,
};

SendByEmail.propTypes = {
  copyEMailText: PropTypes.func.isRequired,
  copyLink: PropTypes.func.isRequired,
  copyLinkText: PropTypes.string,
  isCopyLoading: PropTypes.bool,
  isCopyMailTextLoaded: PropTypes.bool,
  isCopyMailTextLoading: PropTypes.bool,
  link: PropTypes.string.isRequired,
  state: PropTypes.string.isRequired,
};

export default SendByEmail;
